import React, { type ReactElement } from 'react';

import { CheckboxRoundSVG } from '~/src/assets/icons';

import {
  BenefitBox,
  BenefitIcon,
  BenefitsBox,
  BenefitsInner,
  BenefitText,
} from './benefits.styles';
import { BenefitsProps } from './benefits.types';

export function Benefits(props: BenefitsProps): ReactElement {
  const { benefits, ...rest } = props;

  return (
    <BenefitsBox {...rest}>
      <BenefitsInner>
        {benefits.map((benefit, index) => (
          <BenefitBox key={index}>
            <BenefitIcon>
              <CheckboxRoundSVG />
            </BenefitIcon>
            <BenefitText>
              {benefit}
            </BenefitText>
          </BenefitBox>
        ))}
      </BenefitsInner>
    </BenefitsBox>
  );
}
